import React from "react";
import Link from "next/link";
import { useTranslations } from '../../locales/useTranslations';
import { BiPhone, BiEnvelope, BiLogoLinkedin } from "react-icons/bi";

const AppDevelopmentCTA = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="service-details pb-70">
        <div className="container">
          <div className="service-details-content">

            <div className="pt-35">
              <h2>{t('appDevelopment_cta_title1')}</h2>
              <p>
                {t('appDevelopment_cta_description1')}
              </p>
              <p>
                {t('appDevelopment_cta_description2')}
              </p>
            </div>

            <div className="pt-35">
              <h3>{t('appDevelopment_cta_title2')}</h3>
              <p>{t('appDevelopment_cta_description3')}</p>
              <p>{t('appDevelopment_cta_description4')}</p>
              <ul className="app-development-cta-benefits">
                <li dangerouslySetInnerHTML={{ __html: t('appDevelopment_cta_bullet1') }} />
                <li dangerouslySetInnerHTML={{ __html: t('appDevelopment_cta_bullet2') }} />
                <li dangerouslySetInnerHTML={{ __html: t('appDevelopment_cta_bullet3') }} />
              </ul>
            </div>

            <div className="service-details pt-35">
              <div className="service-details-info ">
                <div className="large-info-box">
                  <h4>{t('appDevelopment_cta_ready_title')}</h4>
                  <span><p>{t('appDevelopment_cta_ready_description1')}</p>
                    {t('appDevelopment_cta_ready_description2')}</span>
                </div>

                <div className="single-info-box">
                  <h4>{t('appDevelopment_cta_contact_title')}</h4>
                  <ul className="social">
                    <li>
                      <a href="tel://+4943170577024" target="_blank">
                        <BiPhone />
                      </a>
                    </li>
                    <li>
                      <a href="mailto:info@simplify-data.de" target="_blank">
                        <BiEnvelope />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/simplify-data-gmbh" target="_blank">
                        <BiLogoLinkedin />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="single-info-box">
                  <Link href="/kontakt/" className="default-btn">
                    {t('appDevelopment_cta_consultation')}
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default AppDevelopmentCTA;
